<template>
    <div class="challenge-container">

        <!--第二步 -->
        <template>
            <div class="outbox technicalarticles" v-if="!complete">
                <div class="challenge-header">
                    <div class="title">{{ challengeData.tasp_title }}</div>
                    <div class="introduction" v-html="challengeData.tasp_content"></div>
                </div>

                <!-- 表单 -->
                <el-form ref="form" :model="formData" :rules="rules" label-position="top" class="apply-form">

                    <el-form-item :label="$t('行业类型')" prop="tp_hy_dd_id">
                        <el-select size="small" v-model="formData.tp_hy_dd_id" :placeholder="$t('请选择行业类型')">
                            <el-option v-for="item in commonData.post_ins_list" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('场景分类')" prop="tp_cj_dd_id">
                        <el-select size="small" v-model="formData.tp_cj_dd_id" :placeholder="$t('请选择场景分类')">
                            <el-option v-for="item in commonData.post_scene_list" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item :label="$t('短视频标题')" prop="tp_title">
                        <el-input maxlength="100" v-model="formData.tp_title" :placeholder="$t('请填写短视频标题')">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('短视频来源')" prop="tp_source">
                        <el-select size="small" v-model="formData.tp_source" :placeholder="$t('请选择来源')">
                            <el-option v-for="item in commonData.post_source_list" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <!-- <el-form-item :label="$t('摘要')" prop="tp_desc">
                        <el-input type="textarea" :rows="2" maxlength="200" show-word-limit v-model="formData.tp_desc"
                            :placeholder="$t('选填')"></el-input>
                    </el-form-item> -->

                    <el-form-item :label="$t('短视频')" prop="tp_content">
                        <!-- 上传短视频：仅 1 个，格式 mp4/avi/mov/mkv/wmv -->
                        <Upload v-model="formData.tp_content" upType="FILE"
                            :fileType='["mp4","mov"]' :isUseOss="true" :key="componentKey" />

                    </el-form-item>

                </el-form>

                <div class="action-bar">
                    <el-button type="text" class="submit-btn" v-throttle="2000" @click="submitForm">{{
                        resubmitTasqsId ? $t('重新提交') : $t('发布')
                    }}</el-button>
                </div>
            </div>

        </template>

        <Result v-if="complete" :typeNum="6" :ta_id="ta_id" :tas_id="tas_id" :tasp_id="tasp_id"
            :continueAction="continueAction"></Result>

    </div>
</template>

<script>
import Upload from "@/components/Upload/index";
import Result from './components/result.vue';
import { taskDetailList, taskSubmit } from '@/api/challenge';
import { getcommonData } from "@api/home";

export default {
    name: 'technicalarticles',
    components: {
        Result,
        Upload,
    },
    data() {
        return {
            Videostep: 1,
            complete: false,
            componentKey: 0,
            challengeData: {
                title: '',
                introduction: '',
            },
            commonData: [],
            resubmitTasqsId: null,
            publishedList: [],
            formData: {
                tp_title: '',
                tp_desc: '',
                tp_content: '',
                tp_source: 10,
                tp_hy_dd_id: '',
                tp_cj_dd_id: '',
            },
            rules: {
                tp_title: [
                    {
                        validator: (rule, value, callback) => {
                            if (value === undefined || value === null || /^[\s]*$/.test(String(value))) {
                                callback(new Error(this.$t('请填写短视频标题')));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                tp_hy_dd_id: [
                    { required: true, message: this.$t('请选择行业类型'), trigger: 'blur' }
                ],
                tp_cj_dd_id: [
                    { required: true, message: this.$t('请选择场景分类'), trigger: 'blur' }
                ],
                tp_content: [
                    {
                        validator: (rule, value, callback) => {
                            this.validateShortVideoTpContent(rule, value, callback);
                        },
                        trigger: 'blur',
                    },
                ],
            }
        };
    },
    computed: {
        ta_id() {
            return this.$route.params.ta_id; // 获取路由参数 活动id
        },
        tas_id() {
            return this.$route.params.tas_id; // 获取路由参数 阶段id
        },
        tasp_id() {
            return this.$route.params.tasp_id; // 获取路由参数 试卷id
        },
        resubmitQueryId() {
            const q = this.$route.query.tasqs_id;
            return q ? String(q) : null;
        },
    },
    mounted() {
        this.getData();
    },
    methods: {
        /** 短视频：仅 1 个附件，后缀 mp4/avi/mov/mkv/wmv */
        validateShortVideoTpContent(rule, value, callback) {
            if (value === undefined || value === null || /^[\s]*$/.test(String(value))) {
                callback(new Error(this.$t('请上传短视频')));
                return;
            }
            let arr;
            try {
                arr = typeof value === 'string' ? JSON.parse(value) : value;
            } catch (e) {
                callback(new Error(this.$t('短视频仅支持以下视频格式')));
                return;
            }
            if (!Array.isArray(arr) || arr.length !== 1) {
                callback(new Error(this.$t('仅能上传1个视频')));
                return;
            }
            const exts = ['mp4', 'avi', 'mov', 'mkv', 'wmv'];
            const extOf = (s) => {
                const m = String(s || '').match(/\.([a-z0-9]+)(\?|#|$)/i);
                return m ? m[1].toLowerCase() : '';
            };
            const it = arr[0];
            if (!it || typeof it !== 'object') {
                callback(new Error(this.$t('请上传短视频')));
                return;
            }
            const ext = extOf(it.att_title) || extOf(it.name) || extOf(it.att_url) || extOf(it.url);
            if (!exts.includes(ext)) {
                callback(new Error(this.$t('短视频仅支持以下视频格式')));
                return;
            }
            callback();
        },
        /** 后端常存 storage/... 相对路径，须补成根路径否则会从当前路由目录解析导致加载失败 */
        resolveProofImageUrl(p) {
            const s = String(p == null ? '' : p).trim();
            if (!s) {
                return '';
            }
            if (/^https?:\/\//i.test(s) || s.startsWith('//')) {
                return s;
            }
            if (s.startsWith('/')) {
                return s;
            }
            return `/${s.replace(/^\/+/, '')}`;
        },
        /** 驳回后重新提交：用已入库的视频地址拼成 Upload(FILE) 所需的 JSON（单元素数组） */
        buildUploadJsonFromStoredVideo(row) {
            const raw = row && String(row.tasqs_video_url || '').trim();
            if (!raw) {
                return null;
            }
            const url = this.resolveProofImageUrl(raw);
            const name = this.storedVideoFileListName(url, row.tasqs_video_title);
            const id = Date.now();
            return JSON.stringify([{ att_id: id, att_title: name, att_url: url }]);
        },
        storedVideoFileListName(absUrl, titleFallback) {
            try {
                const path = String(absUrl).split('?')[0];
                const seg = path.split('/').pop();
                if (seg && /\.[a-z0-9]{2,5}$/i.test(seg)) {
                    return decodeURIComponent(seg);
                }
            } catch (e) { /* ignore */ }
            const t = String(titleFallback || 'video').replace(/[\\/]/g, '');
            return /\.[a-z0-9]{2,5}$/i.test(t) ? t : `${t}.mp4`;
        },
        applyResubmitPrefill(list) {
            this.resubmitTasqsId = null;
            const qid = this.resubmitQueryId;
            if (!qid) {
                return;
            }
            const row = (list || []).find((x) => String(x.tasqs_id) === qid);
            if (!row || row.tasqs_status !== 'error') {
                this.$message.warning(this.$t('当前记录不可重新提交'));
                return;
            }
            this.resubmitTasqsId = parseInt(qid, 10);
            this.formData.tp_title = row.tasqs_video_title || '';
            if (row.tasqs_hy_dd_id) {
                this.formData.tp_hy_dd_id = row.tasqs_hy_dd_id;
            }
            if (row.tasqs_cj_dd_id) {
                this.formData.tp_cj_dd_id = row.tasqs_cj_dd_id;
            }
            if (row.tp_desc != null && row.tp_desc !== undefined) {
                this.formData.tp_desc = String(row.tp_desc);
            }
            if (row.tp_source != null && row.tp_source !== '') {
                const s = Number(row.tp_source);
                if (!Number.isNaN(s)) {
                    this.formData.tp_source = s;
                }
            }
            const videoJson = this.buildUploadJsonFromStoredVideo(row);
            if (videoJson) {
                this.formData.tp_content = videoJson;
            }
            this.componentKey += 1;
        },
        async getData() {
            const res = await taskDetailList({
                ta_id: this.ta_id,
                tas_id: this.tas_id,
                tasp_id: this.tasp_id,
            });
            if (res.status == 200) {
                if (res.data.status == false) {
                    this.$message.error(res.data.msg);
                    return;
                }
                this.challengeData = res.data.paper;
                this.publishedList = res.data.published_short_videos || [];
                this.applyResubmitPrefill(this.publishedList);
            }
            const res2 = await getcommonData();
            if (res2.status == 200) {
                this.commonData = res2.data;
            }
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 表单验证通过，可以提交数据
                    const payload = { ...this.formData };
                    if (this.resubmitTasqsId) {
                        payload.tasqs_id = this.resubmitTasqsId;
                    }
                    let subObj = {
                        ta_id: this.challengeData.ta_id,
                        tas_id: this.challengeData.tas_id,
                        tasp_id: this.challengeData.tasp_id,
                        dd_question_type: this.challengeData.dd_question_type,
                        data: payload,
                    };
                    this.submitData(subObj);
                } else {
                    // this.$message.error('请检查表单内容！');
                    return false;
                }
            });
        },
        async submitData(subObj) {
            const loading = this.$loading({
                lock: false,
                text: this.$t('加载中'),
                background: 'rgba(0, 0, 0, 0.1)'
            });
            const res = await taskSubmit(subObj);
            loading.close();
            if (res.status == 200) {
                this.complete = true;
                this.resubmitTasqsId = null;
                this.formData = {
                    tp_title: '',
                    tp_desc: '',
                    tp_content: '',
                    tp_source: 10,
                    tp_hy_dd_id: '',
                    tp_cj_dd_id: '',
                };
                this.componentKey += 1;
                window.scrollTo({ top: 0, behavior: 'smooth' });
                this.$message.success(this.$t('发布成功'));
            } else {
                // this.$message.error(this.$t('提交失败'));
            }
        },
        continueAction() {
            this.complete = false;
            this.getData();
        }
    }
};
</script>
<style lang="scss" scoped>
.outbox {
    min-width: 1200px;
    max-width: 1680px;
    margin: 0 auto 16px;
    background: #fff;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 32px 32px 0;

    &:last-child {
        margin-bottom: 0;
    }
}

.challenge-container {
    width: 100%;
    padding: 80px 120px 20px;
    background: #f9f9f9;
    min-height: 100vh;
    color: #191919;

    .technicalarticles {
        //   min-height: calc(100vh - 100px);
        padding-bottom: 32px;
    }

    .challenge-header {
        margin-bottom: 32px;

        .title {
            font-size: 26px;
            line-height: 30px;
            margin-bottom: 16px;
        }

        .introduction {
            font-size: 14px;
            line-height: 24px;
            font-weight: 300;
            color: #595959;
        }
    }

    .section-title {
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 14px;
    }


    .action-bar {
        text-align: center;
        padding-top: 24px;
        border-top: 1px dashed rgb(230, 230, 230);

        .submit-btn {
            box-sizing: border-box;
            font-size: 14px;
            border: 1px solid rgb(179, 0, 0);
            border-radius: 20px;
            width: 86px;
            background: rgb(255, 255, 255);
            color: #B30000;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                background-color: rgba(179, 0, 0, 0.1);
            }
        }

        .submit-btn--wide {
            width: auto;
            min-width: 100px;
            padding: 0 20px;
        }
    }
}

.apply-form {
    width: 100%;

    ::v-deep .tox.tox-tinymce.tox-fullscreen {
        background-color: transparent;
        box-sizing: border-box;
        padding-top: 60px;
    }

    ::v-deep .el-form-item {
        margin-bottom: 24px;

        .el-form-item__label {
            padding: 0;
            line-height: 22px;
            margin-bottom: 8px;
            color: #191919;
        }

        .el-form-item__content {
            line-height: normal;
        }

        .el-input:not(.el-input--suffix) {
            width: 100%;

            .el-input__inner {
                width: 100%;
                height: 36px;
                line-height: 36px;
            }
        }

        .el-select {
            width: 75%;
            // .el-input__inner {
            //   width: 100%;
            //   height: 32px;
            //   line-height: 32px;
            // }
            // .el-input__suffix{
            //   top: 4px;
            // }
        }

        .el-textarea {
            width: 100%;

            .el-textarea__inner {
                width: 100%;
                line-height: 22px;
            }

            .el-input__count {
                right: 10px;
                bottom: 2px;
                font-size: 12px;
                color: #808080;
                background: transparent;
                line-height: 20px;
                height: 20px;
            }
        }

        .upload-demo {
            width: 100%;

            .el-upload-dragger {
                width: 100%;
                height: 150px;

                .el-icon-picture {
                    font-size: 36px;
                    color: #8abef3;
                    margin: 32px 0 16px;
                    line-height: 40px;
                }
            }

            .el-upload {
                width: 100%;
            }

            .el-upload__tip {
                color: #808080;
            }

            .el-upload__text {
                width: 100%;

                &.text2 {
                    color: #808080;
                    font-size: 12px;
                }

                em {
                    color: #0067D1;
                }
            }
        }

        .tox .tox-toolbar {
            background-color: #fff;
        }

    }
}
</style>